<bw-action-article [brightsideWebFb]="{ event_name: analyticsName }" *ngIf="company">
  <ui-nav-exit-back header-actions [trackingDetail]="{ event_name: 'select_client_type_dismissed' }" (exitActionHandler)="goBack()"></ui-nav-exit-back>

  <div header-title>
    <div class="flex-row mb-md">
      <typography title-medium class="mr-md">
        {{ "SELECT_EMPLOYEE_TYPE_TITLE" | translate }}
      </typography>
      <img *ngIf="!displayDefaultIcon" width="52" src="{{ cdnUrl }}images/app/{{company|lowercase}}.png" (error)="displayDefaultIcon = true">
    </div>
  </div>
  <div content-section>
    <bw-spinner brightsideWebTimeout *ngIf="processing"></bw-spinner>
    <bw-action-cell
      label="{{ 'EMPLOYEE' | translate }}"
      detail="{{ 'EMPLOYEE_DESC' | translate:{article:article,company:company|titlecase} }}"
      iconName="chevron_right"
      [emphasize]="true"
      class="full-width"
      (actionCellClick)="submitClientType('employment');"
    ></bw-action-cell>
    <bw-action-cell
      label="{{ 'HOUSEHOLD_MEMBER' | translate }}"
      detail="{{ 'HOUSEHOLD_MEMBER_DESC' | translate:{article:article,company:company|titlecase} }}"
      iconName="chevron_right"
      [emphasize]="true"
      class="full-width"
      (actionCellClick)="submitClientType('dependent');"
    ></bw-action-cell>
    <bw-action-cell *ngIf="userFromSubDomain"
      label="{{ 'NEITHER' | translate }}"
      detail="{{ 'NOT_AFFILIATED_DESC' | translate:{article:article,company:company|titlecase} }}"
      iconName="chevron_right"
      [emphasize]="true"
      class="full-width"
      (actionCellClick)="submitClientType('neither');"
    ></bw-action-cell>
  </div>
</bw-action-article>
